import styled from 'styled-components';

/**
 * Outer wrapper for the dialog body. Keeps the embedded
 * {@link RunConfigForm} laid out vertically with a sensible minimum
 * width on narrow viewports.
 */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 360px;
`;
